import { uniqueId } from "lodash";
import React, {
    FormEvent,
    ReactChild,
    useCallback,
    useEffect,
    useMemo,
    useState,
} from "react";
import { AiOutlinePlusSquare } from "react-icons/ai";
import { useParams } from "react-router-dom";
import useApi from "../../hooks/useApi";
import { TrailModule } from "../../types/TrailModule";
import { ModulesFields } from "./ModulesFields";

export const Modules = ({ modules }: Props) => {
    const api = useApi();
    const { id } = useParams<any>();

    const [countModules, setCountModules] = useState<number>(0);

    const handleSubmit = useCallback(
        async (e: FormEvent<HTMLFormElement>, idModule?: string) => {
            e.preventDefault();
            e.currentTarget.checkValidity();
            if (!e.currentTarget) return;
            const data = new FormData(e.currentTarget);

            if (idModule) {
                data.append("_method", "PATCH");
                return await api
                    .post(`/admin/trails/module/${idModule}`, data)
                    .then((res) => {
                          window.location.reload();
                    })
                    .catch(console.log);
            }
            
            return await api
            .post(`/admin/trails/${id}/new-module`, data)
            .then((res) => {
              window.location.reload()
            })
            .catch(console.log);

        },
        [api, id]
    );

    const renderModules = useMemo((): ReactChild[] => {
        let moduleFields: ReactChild[] = [];
        if (countModules === 0) return moduleFields;
        for (let i = 0; i < countModules; i++) {
            if (modules) {
                moduleFields.push(
                    <form onSubmit={handleSubmit}>
                        <ModulesFields newModule name={""+i} 
                            remove={() => setCountModules(prev => prev - 1)} 
                        /> 
                    </form>
                );
            } else moduleFields.push(<ModulesFields  remove={(i + 1) === countModules && countModules > 1 ? () => setCountModules(prev => prev - 1) : undefined} />);
        }
        return moduleFields;
    }, [setCountModules,countModules,modules,handleSubmit]);

    useEffect(() => {
        if (modules?.length) return setCountModules(0);
        return setCountModules(1);
    }, [modules,setCountModules]);

    return (
        <>
            <div className="text-lg font-bold">Blocos da trilha</div>
            <div className="grid grid-cols-1 gap-2">
                {modules?.map((item) => (
                    <form
                        onSubmit={(e) => handleSubmit(e, item.id)}
                        key={item.id}
                    >
                        <ModulesFields module={item} name={item.id} />
                    </form>
                ))}
                {renderModules.map((item) => (
                    <div key={uniqueId()}>{item}</div>
                ))}
                <div
                    className="flex cursor-pointer justify-center p-2 items-center border-2 border-dotted 
                                 border-gray-600 text-md my-2"
                    onClick={() => setCountModules((prev) => prev + 1)}
                >
                    <AiOutlinePlusSquare className="mr-2" /> Adicionar bloco
                </div>
            </div>
        </>
    );
};

interface Props {
    modules?: TrailModule[];
}
